module.exports = __webpack_public_path__ + "prod/1.42.2/img/multiVersion-01.8eaada95.jpg";